import { useCallback, useState } from "react";
import type { Selection } from "./types";

export function useSelection() {
  const [selection, setSelection] = useState<Selection>(null);

  const selectAttribute = useCallback((attributeId: number) => {
    setSelection({ type: "attribute", attributeId });
  }, []);

  const selectColumn = useCallback(
    (attributeId: number, columnSortOrder: number) => {
      setSelection({ type: "tabular-column", attributeId, columnSortOrder });
    },
    [],
  );

  const clearSelection = useCallback(() => {
    setSelection(null);
  }, []);

  return { selection, selectAttribute, selectColumn, clearSelection };
}
